// extracted by mini-css-extract-plugin
export default {"imageWrapper":"IK-z","twoColumnImage":"JK-z"};